export default {
  STRATEGY_SOWOS_MODERATE_REPOSITORY: Symbol.for('STRATEGY_SOWOS_MODERATE_REPOSITORY'),
  HIRE_STRATEGY_MODERATE_COMMAND: Symbol.for('HIRE_STRATEGY_MODERATE_COMMAND'),
  AVAILABLE_TO_HIRE_STRATEGY_MODERATE_STATE_MANAGER: Symbol.for('AVAILABLE_TO_HIRE_STRATEGY_MODERATE_STATE_MANAGER'),
  GET_IS_AVAILABLE_TO_HIRE_STRATEGY_MODERATE_QUERY: Symbol.for('GET_IS_AVAILABLE_TO_HIRE_STRATEGY_MODERATE_QUERY'),
};
